<template>
  <div class="page">
    <sunset-note-stats-query-bar
        v-slot="{ params, meta, query }"
        path-base="/sunset/reports/note-stats/totals"
    >
      <section>
        <h2>Leaderboard</h2>

        <NoteStatsCsvButton mode="leaderboard" :params="params" :query="query" />

        <!-- refactored: single-source params/meta/query -->
        <UserSummaryTable
            :params="params"
            :meta="meta"
            :query="query"
        />
      </section>
    </sunset-note-stats-query-bar>
  </div>
</template>

<script>
import CoreSummaryTable from './components/aggregated_summary/global_totals.vue';
import UserSummaryTable from './components/aggregated_summary/leaderboard.vue';
import loadingCube from 'loaders/record_loader.vue';
import SunsetNoteStatsQueryBar from 'pages/sunset/reports/notestats/components/shared/query_controls.vue';
import NoteStatsCsvButton from './components/shared/csv_button.vue';

export default {
  name: 'aggregated_summary_page',
  components: {
    SunsetNoteStatsQueryBar,
    loadingCube,
    CoreSummaryTable,
    UserSummaryTable,
    NoteStatsCsvButton,
  },
};
</script>

<style lang="scss" scoped>
@use "./scss/shared" as *;
</style>
